<div class="kt-login__wrapper">
	<div class="kt-login__container">
		<!--begin::Body-->
		<div class="kt-login__body">
			<div class="kt-login__logo">
				<a href="#">
					<img src="assets/media/company-logos/logo-2.png" alt="logo Fyffes">
				</a>
			</div>
			<!--begin::Signin-->
			<div class="kt-login__signin">
				<!--begin::Head-->
				<div class="kt-login__head">
					<h3>Sign In To Fyffes Portal</h3>
				</div>
				<!--end::Head-->
				<div class="kt-login__form">
					<kt-auth-notice></kt-auth-notice>
					<!--begin::Form-->
					<form class="kt-form" [formGroup]="loginForm" autocomplete="off">
						<div class="form-group">
							<mat-form-field class="login-form-field">
								<mat-label class="mat-label">{{ 'AUTH.INPUT.USERNAME' | translate }}</mat-label>
								<input matInput type="username" class="loginInput" placeholder="{{ 'AUTH.INPUT.USERNAME' | translate }}" formControlName="username" autocomplete="off"/>
								<mat-error *ngIf="isControlHasError('username','required')">
									<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
								</mat-error>
								<mat-error *ngIf="isControlHasError('username','username')">
									<strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}</strong>
								</mat-error>
								<mat-error *ngIf="isControlHasError('username','minlength')">
									<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
								</mat-error>
								<mat-error *ngIf="isControlHasError('username','maxlength')">
									<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="form-group">
							<mat-form-field class="login-form-field">
								<mat-label class="mat-label">{{ 'AUTH.INPUT.PASSWORD' | translate }}</mat-label>
								<input matInput type="password" class="loginInput" placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}" [type]="hide ? 'password' : 'text'" formControlName="password" autocomplete="off"/>
								<mat-icon class="mat-icon-rtl-mirror md-2" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
								<mat-error *ngIf="isControlHasError('password','required')">
									<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
								</mat-error>
								<mat-error *ngIf="isControlHasError('password','minlength')">
									<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
								</mat-error>
								<mat-error *ngIf="isControlHasError('password','maxlength')">
									<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
								</mat-error>
							</mat-form-field>
							<div class="text-right"><a style="color: #939598; font-size: 16px;"  routerLink="/auth/forgot-password" tabindex="-1">{{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }}?</a></div>
						</div>
						<div class="kt-login__extra" [hidden]="isMobile">
							<mat-checkbox style="color: #939598; font-size: 18px;" formControlName="rememberMe">
								{{ 'AUTH.GENERAL.REMEMBER' | translate }}
							</mat-checkbox>
						</div>

						<!--begin::Action-->
						<div class="kt-login__actions">
							<button mat-raised-button color="btnprimary" (click)="submit()" [disabled]="loading" id="kt_login_signin_submit" class="button-login">
								<span *ngIf="!loading" class="button-content">{{ 'AUTH.LOGIN.BUTTON' | translate }}</span>
							  	<span *ngIf="loading" class="spinner-container">
									<span class="kt-spinner kt-spinner--md kt-spinner--light"></span>
							  	</span>
							</button>
						</div>						  
						<!--end::Action-->
					</form>
					<!--end::Form-->
				</div>

				<!--end::Signin-->
			</div>
		</div>
		<!--end::Body-->
	</div>
</div>
